import React, { FC, PropsWithChildren, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

interface PublicRouteProps {}

const PublicRoute: FC<PropsWithChildren<PublicRouteProps>> = ({ children }) => {
  const authContext = useContext(AuthContext);

  if (typeof authContext?.isAuthenticated !== "boolean") return null;

  return !authContext.isAuthenticated ? <>{children}</> : <Navigate to="/home" replace />;
};

export default PublicRoute;
